export const CHECKBOX_LABEL_POSITIONS = {
  AFTER: 'after',
  BEFORE: 'before',
};

export const CHECKBOX_SIZES = {
  LARGE: 'large',
  SMALL: 'small',
  STANDARD: 'standard',
};
